import { api } from "../api";

export const getHomeBaseData = async () => {
  let url = "/home";
  return await api.get(url);
};

export const getProvidences = async () => {
  let url = "/home/providences";

  return await api.get(url);
};

export const getFilteredProjects = async (selectedProgress, selectedStages, pdcIds, clientIds, stateIds) => {
  let url = "/home/projects";

  // Monta params dinamicamente - não envia stageIds se vazio (todas selecionadas = mais rápido)
  const params = {
    progressIds: selectedProgress,
    limit: 100, // Lista até 100 projetos para a HomePage
    fullRelations: true, // Inclui objetos stage/providence completos
    sortByDeadline: true, // Ordena por prazo (igual à API antiga)
  };

  // Só adiciona filtros que têm valor
  if (selectedStages && selectedStages.length > 0) {
    params.stageIds = selectedStages;
  }
  
  if (pdcIds && pdcIds.length > 0) {
    params.pdcIds = pdcIds;
  }
  
  if (clientIds && clientIds.length > 0) {
    params.clientIds = clientIds;
  }
  
  if (stateIds && stateIds.length > 0) {
    params.stateIds = stateIds;
  }

  const response = await api.get(url, { params });

  // API retorna { data: [], pagination: {} }, extrai apenas o array de projetos
  return { ...response, data: response.data.data };
};

export const updateFilteredProject = async (
  projectId,
  historyStageId,
  historyProvidenceId,
  stageId,
  providenceId,
  deadline
) => {
  let url = `/home/projects/${projectId}`;

  return await api.put(url, {
    historyStageId: historyStageId,
    historyProvidenceId: historyProvidenceId,
    stageId: stageId,
    providenceId: providenceId,
    deadline: deadline,
  });
};
